export default __webpack_public_path__ + "static/media/subsection-our-story.f37cb7c1.svg";